<template>
	<v-navigation-drawer :value="value" @input="$emit('input', $event)" app temporary>
		<v-list nav>
			<div v-frag v-if="isLoggedIn">
				<v-list-item to="/fields" :inactive="$router.currentRoute.path === '/fields'">
					<v-list-item-title>Fields</v-list-item-title>
				</v-list-item>

				<v-list-item to="/field/new">
					<v-list-item-title>Draw Field</v-list-item-title>
				</v-list-item>

				<v-list-item to="/sampling-collection">
					<v-list-item-title>Sampling Collections</v-list-item-title>
				</v-list-item>

				<add-stratification-dialog v-slot="{ attrs, on }" @open="$emit('input', false)">
					<v-list-item v-bind="attrs" v-on="on">
						<v-list-item-title>Add Stratification</v-list-item-title>
					</v-list-item>
				</add-stratification-dialog>

				<v-list-item to="/groups">
					<v-list-item-title>Groups</v-list-item-title>
				</v-list-item>

				<v-list-item to="/admin">
					<v-list-item-title>Move Fields</v-list-item-title>
				</v-list-item>

				<v-list-item to="/settings">
					<v-list-item-title>Settings</v-list-item-title>
				</v-list-item>
			</div>

			<v-list-item href="https://our-sci.gitlab.io/software/soilstack-tutorials/" target="_blank">
				<v-list-item-content>
					<v-list-item-title>SoilStack Help</v-list-item-title>
				</v-list-item-content>
				<v-list-item-icon>
					<v-icon>mdi-help-circle-outline</v-icon>
				</v-list-item-icon>
			</v-list-item>
		</v-list>

		<template v-slot:append>
			<div dark class="grey--text text-caption ml-4 mb-2">
				{{ version }}
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { defineComponent, onUnmounted, ref } from '@vue/composition-api';
import AddStratificationDialog from '@/components/dialog/AddStratificationDialog.vue';
import { AuthService } from '../../services/storageService';

export default defineComponent({
	components: {
		AddStratificationDialog,
	},
	props: {
		value: {
			type: Boolean,
		},
	},
	setup: () => {
		const lcl = JSON.parse(process.env.VUE_APP_LCL);
		const version = `Version: ${lcl.shortHash}`;

		const isLoggedIn = ref(Boolean(AuthService.getToken()));

		const onAuthServiceTokenChange = () => {
			isLoggedIn.value = Boolean(AuthService.getToken());
		};

		window.addEventListener('authservicetokenchange', onAuthServiceTokenChange);

		onUnmounted(() => {
			window.removeEventListener('authservicetokenchange', onAuthServiceTokenChange);
		});

		return {
			version,
			isLoggedIn,
		};
	},
});
</script>
